<div
  animate.enter="animate-down"
  animate.leave="animate-up"
class="py-3 px-5 flex flex-col gap-8">
  <app-top-banner [title]="'My Profile' | concat | translate "></app-top-banner>

  <div *ngIf="authUser as profile" class="grid grid-cols-12 gap-3">
    <div [ngClass]="viewUpdate ? 'col-span-8':'col-span-12'">
      <div class="grid grid-cols-12 gap-4 bg-white px-4 py-5 rounded-xl">
        <div class="col-span-12">
          <div class="flex items-center gap-5">
            <app-info [info]="'Personal Details' | concat | translate" class="flex-grow" icon="cases"></app-info>
          </div>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Firstname' | concat | translate"
                             [value]="profile?.profileRole?.roleName"></view-details-item>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Middlename' | concat | translate"
                             [value]="profile?.profileRole?.roleDescription"></view-details-item>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Lastname' | concat | translate"
                             [value]="profile?.profileRole?.roleCreateddate"></view-details-item>
        </div>


        <!-- <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Phone Number' | concat | translate"
                             [value]="profile?.profileRole?.profilePhone"></view-details-item>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Email Address' | concat | translate"
                             [value]="profile?.profileRole?.email"></view-details-item>
        </div>


        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Status' | concat | translate"
                             [value]="profile?.profileRole?.isDeactivated ? 'INACTIVE' : 'ACTIVE'"></view-details-item>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Created On' | concat | translate"
                             [valueType]="'date'" [value]="profile?.profileRole?.createdDate"></view-details-item>
        </div> -->
      </div>

      <div class="grid grid-cols-12 gap-4 bg-white px-4 py-5 rounded-xl">
        <div class="col-span-12">
          <div class="flex items-center gap-5">
            <app-info [info]="'Other Details' | concat | translate" class="flex-grow" icon="cases"></app-info>
          </div>
        </div>

        <!-- <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Institution' | concat | translate"
                             [value]="profile?.userInstitution?.institutionEngName"></view-details-item>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Designation' | concat | translate"
                             [value]="profile?.userDesignation?.shortForm"></view-details-item>
        </div> -->

        <div class="col-span-12 sm:col-span-6 md:col-span-4">
          <view-details-item [key]="'Role' | concat | translate"
                             [value]="profile?.profileRole?.roleName"></view-details-item>
        </div>
      </div>
    </div>

  </div>

</div>
